import { render, staticRenderFns } from "./SalaDeProcedimento.vue?vue&type=template&id=70dede93&"
import script from "./SalaDeProcedimento.vue?vue&type=script&lang=js&"
export * from "./SalaDeProcedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports